import React, { useEffect } from 'react'
import xss from 'xss'
import get from 'lodash/get'
import dynamic from 'next/dynamic'
import { replaceSeries } from './common'
import Loading from 'Components/loading'
import formatTime from 'lib/format-time'

import { IArticle } from './home'

import { fullSeries } from './series-names'
import getCarIds from 'lib/get-cars-from-series'
const Video = dynamic(() => import('Components/video'), {
  ssr: false,
  loading: () => <Loading />,
})

interface IProps {
  article: IArticle
  isVideo: boolean
  group_id: string
}

function handleContent(content: string): string {
  return content.replace(/\{!--.*?--\}/g, '')
}
const HTML_BR_REG = /^<br>$/
// 处理换行符
const processBr = (p: HTMLParagraphElement) => {
  // 针对编辑器最新的换行符<p><br></p>进行处理
  if (HTML_BR_REG.test(p.innerHTML)) {
    p.classList.add('syl-page-br')
    // if (!p.nextElementSibling) { // 行尾BR不处理
    //   return
    // }
    // if (!p.previousElementSibling) { // 行首syl-page-br直接移除
    if (p.parentNode) {
      p.parentNode.removeChild(p)
    }
    // return
    // }
    // 处理段落中间的BR
    // const shoudleHideBr = (
    //   // 段落和图片之间的换行隐藏
    //   (p.nextElementSibling.classList.contains('pgc-img') && p.previousElementSibling.tagName === 'P') ||
    //   // 连续多个换行隐藏掉后面的
    //   p.previousElementSibling.classList.contains('syl-page-br') ||
    //   // 图片后面的换行符隐藏
    //   p.previousElementSibling.classList.contains('pgc-img')
    // )
    // if (shoudleHideBr) {
    //   p.classList.add('syl-page-br-hide')
    // }
  }
  /**
   * 两个br元素之间若包含textNode，不认为是连续换行。Migrate from tt_article_detail
   */
  const originBrs = Array.from(p.querySelectorAll('br'))
  originBrs.forEach(br => {
    const preNode = br.previousSibling
    if (preNode && preNode.nodeType === Node.TEXT_NODE) {
      br.classList.add('sysbr')
    }
  })
}

export default function Content({ article, isVideo, group_id }: IProps) {
  /* 渲染标题 */
  function renderHeader() {
    return (
      <div className="details">
        <h1 className="title">{article.title}</h1>
        <div className="info">
          <span>{article.source}</span>
          <span className="time">
            {formatTime(article.publish_time * 1000)}
          </span>
        </div>
        <style jsx>
          {`
            .details {
              padding: 20px 0 0;
            }
            .title {
              line-height: 48px;
              font-size: 34px;
              font-weight: 500;
            }
            .info {
              line-height: 20px;
              font-size: 14px;
              margin-bottom: 20px;
              color: #999;
            }
            .time {
              margin-left: 8px;
            }
          `}
        </style>
      </div>
    )
  }

  /* 渲染文章信息 */
  function renderContent(type: 'mix' | 'article') {
    const imageList = get(article, 'gallery_info.image_list', [])
    if (!article.content && imageList.length) {
      return (
        <div className="image-list">
          {imageList.map((img: any) => {
            return (
              <div key={img.image_uri} className="item">
                <img src={`//p9.pstatp.com/large/${img.image_uri}`} />
                <p>{img.desc}</p>
              </div>
            )
          })}
          <style jsx>
            {`
              .image-list {
                padding: 0 0 60px;
              }
              p {
                line-height: 1.75;
                margin-top: 20px;
                font-size: 16px;
              }
              img {
                width: 100%;
                margin-top: 20px;
              }
            `}
          </style>
        </div>
      )
    }
    if (type === 'mix') {
      const newContent = article?.content
        ?.replace(/{!--\s*PGC_VIDEO:(.*)--}/, '')
        .split('<p></p>')
      return (
        <div className="details">
          {newContent.map((section, index) => {
            return (
              <React.Fragment key={index}>
                <article
                  id="article"
                  className="article-content"
                  dangerouslySetInnerHTML={{
                    __html: section ? handleContent(section) : '',
                  }}
                />
                {index === 0 ? (
                  <section>
                    <Video vid={article.video_info.vid} group_id={group_id} />
                  </section>
                ) : null}
              </React.Fragment>
            )
          })}
          <style jsx>
            {`
              section {
                width: 750px;
                height: 423px;
              }
              .details {
                padding: 0 0 60px;
              }
            `}
          </style>
        </div>
      )
    }
    if (type === 'article') {
      return (
        <div className="details">
          <article
            id="article"
            className="article-content"
            dangerouslySetInnerHTML={{
              __html: article.content
                ? handleContent(article.content)
                : `
            <div style="width: 100%; text-align: center;">
              <img src="${require('static/error-pic@3x.jpg')}" style="width: 240px; height: 240px;"/>
              文章消失了，再去看看别的吧～
            </div>
          `,
            }}
          />
          <style jsx>
            {`
              .details {
                padding: 0 0 60px;
              }
            `}
          </style>
        </div>
      )
    }
  }

  function renderArticle(isVideo: boolean, content: string) {
    if (isVideo) {
      return renderContent('mix')
    } else {
      return renderContent('article')
    }
  }

  useEffect(() => {
    const pDom = Array.from(document.body.querySelectorAll('p'))
    pDom.forEach(p => {
      processBr(p)
    })
    const articleDOM = document.querySelector('#article') as HTMLElement

    const doReplace = replaceSeries(
      articleDOM,
      fullSeries,
      async ({ seriesId, seriesName }) => {
        const carIds = await getCarIds(String(seriesId))
        if (carIds === '') {
          return `<a style="color: #205be6" href='/auto/series/${seriesId}' target="_blank">${seriesName}</a>(<a style="color: #205be6"  href='/auto/series/${seriesId}/images' target="_blank">图片</a>)`
        }
        return `<a style="color: #205be6" href='/auto/series/${seriesId}' target="_blank">${seriesName}</a>(<a style="color: #205be6"  href='/auto/series/${seriesId}/images' target="_blank">图片</a>|<a style="color: #205be6"  href='/auto/params?carIds=${carIds}' target="_blank">配置</a>|<a style="color: #205be6"  href='/dealer/${seriesId}' target="_blank">询价</a>)`
      }
    )
    const asyncCall = window.requestAnimationFrame
    asyncCall(doReplace)
  }, [])
  return (
    <article>
      {renderHeader()}
      {renderArticle(isVideo, article.content)}
      <style jsx>
        {`
          section {
            width: 750px;
            height: 423px;
            margin: 20px 0 60px;
          }
          :global(.article-content p, .article-content h1) {
            line-height: 1.75;
            margin-top: 20px;
            font-size: 16px;
          }
          :global(.article-content img) {
            width: 100%;
            height: 100%;
            margin: 20px auto;
            display: block;
          }
        `}
      </style>
    </article>
  )
}
